import {
	makeApiRequest,
	Auth,
	ApiRequestPostData,
	ApiRequestPostDataWithDate,
	isApiRequestPostData
} from "api/makeApiRequest";
import { ApiRequest } from "api/makeApiRequest/ApiRequest";
import { ValidationCallback } from "validation/validate";
import { addPostProcessingToResponse } from "api/utils/addPostProcessingToResponse";

export const makeSubmitData = <
	RawPostData extends ApiRequestPostDataWithDate,
	Output = {},
	RawApiOutput = Output
>(
	endPoint: string,
	flagValidationErrors: ValidationCallback<RawApiOutput> = (input, flag) => {},
	preProcessor?: (data: RawPostData) => ApiRequestPostData,
	postProcessor?: (
		arg: RawApiOutput | undefined,
		requestPayload: ApiRequestPostDataWithDate
	) => Output,
	opts?: {
		waitForTimezone?: boolean;
	}
) => (data: RawPostData, auth: Auth) => {
	const post = preProcessor ? preProcessor(data) : data;
	if (!isApiRequestPostData(post)) {
		throw new Error(
			"Invalid post data - consider adding a preProcessor to convert it to the correct format"
		);
	}

	const req = makeApiRequest<RawApiOutput>(endPoint, {
		data: {
			post
		},
		flagValidationErrors,
		auth,
		waitForTimezone: !!opts && !!opts.waitForTimezone
	});

	if (postProcessor) {
		return addPostProcessingToResponse(req, postProcessor, post);
	}

	return (req as unknown) as ApiRequest<Output>;
};
